import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "capital-list",
  data: function data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 20,
        type: "",
        userName: "",
        phone: "",
        voucher: ""
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0 // 总数
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    pageChange: function pageChange(pageNum) {
      this.searchForm.pageNum = pageNum;
      this.getData();
    },
    getData: function getData(type) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (type === "search") {
                _this2.searchForm.pageNum = 1;
              }
              _this2.tableLoading = true;
              // let res = await this.$api.getCapitalWithdrawList(this.searchForm);
              _context2.n = 1;
              return _this2.$api.getUserRecordList(_this2.searchForm);
            case 1:
              res = _context2.v;
              _this2.tableData = res.data.content;
              _this2.total = res.data.totalSize;
              _this2.tableLoading = false;
              _this2.getUserListByIds(_this2.tableData, "userId");
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    resetSearch: function resetSearch() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 20,
        type: "",
        userName: "",
        phone: "",
        voucher: ""
      };
      this.getData('search');
    }
  }
};